import { autoinject } from "aurelia-dependency-injection";
import { transient } from "aurelia-dependency-injection";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { DialogServiceConstants } from "../../../../constants/basics/dialog.constants";

@autoinject
@transient()
export class OnboardingPlugins {

    public constructor(private dialogClientService: DialogClientService) { }

    public model: any;

    public activate(model: any) {
        this.model = model;
    }

    createDynamicOnboardingPlugin() {
        this.dialogClientService.show(DialogServiceConstants.URLs.CreateDynamicOnboardingPluginDialog, { reloadData: () => this.model.datagrid.reloadData() }, false, false, false);
    }
}
